/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Ui_ReviewInputs */

const en_wc_tut_ui_review = /** @type {(inputs: Wc_Tut_Ui_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review and View: spelling, comments, track changes, zoom, Navigation pane, dark mode.`)
};

/**
* | output |
* | --- |
* | "Review and View: spelling, comments, track changes, zoom, Navigation pane, dark mode." |
*
* @param {Wc_Tut_Ui_ReviewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_ui_review = /** @type {((inputs?: Wc_Tut_Ui_ReviewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Ui_ReviewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_ui_review(inputs)
});
export { wc_tut_ui_review as "wc.tut.ui.review" }